export interface NorthAmericaTerms {
  general_north_america: boolean
  payment_north_america: boolean
}

export interface DefaultTerms {
  general: boolean
  consumer: boolean
  payment: boolean
}

export type TermsData = NorthAmericaTerms | DefaultTerms

export const MARKETS = ['default', 'north_america', 'kootstra'] as const
export type Market = typeof MARKETS[number]
